import { useLocation, Outlet } from "react-router-dom";
import styled from "styled-components";

import Stage from "./Stage";
import Images from "./Images";
import Header from "./../components/Header";
import Footer from "./../components/Footer";
import Navigation from "./../components/Navigation";
import SEO from "./../components/SEO";
import StructuredData from "./../components/StructuredData";
import { useLanguage, SUPPORTED_LANGS, DEFAULT_LANG } from "../i18n";

const Container = styled.div`
    display: block;
    max-width: 1100px;
    background-color: white;
    margin-left: auto;
    margin-right: auto;
    box-shadow: -4px 1px 8px gray;
`;

const Top = styled.div`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 650px) {
        /* flex-direction: column-reverse; */
    }
`;

export default function Home() {
    const path = useLocation().pathname;
    const { lang } = useLanguage();

    // Strip language prefix to get the page segment
    let cleanPath = path;
    if (lang !== DEFAULT_LANG) {
        cleanPath = path.replace(new RegExp(`^/${lang}`), '');
    }

    let page = cleanPath.split("/").filter(Boolean)[0] || "home";
    let event_id = cleanPath.split("/")[3];

    // Determine SEO pageKey based on current page
    const pageKey = page === "home" ? "home" : page;

    return (
        <Container>
            <SEO pageKey={pageKey} />
            <StructuredData />
            <Top id="top">
                <Navigation page={page} />
                <Header page={page} />
            </Top>
            <Stage event_id={ event_id } page={page} />
            <Images />
            <Outlet />
            <Footer />
        </Container>
    );
}
